/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelHotelSellChangeReportPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-hotel-sell-change-report-post';
import { ApiHotelHotelSellChangeReportPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-hotel-sell-change-report-post';
import { apiHotelHotelSellReportPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-hotel-sell-report-post';
import { ApiHotelHotelSellReportPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-hotel-sell-report-post';
import { apiHotelStatisticalReportBreakfastPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-breakfast-post';
import { ApiHotelStatisticalReportBreakfastPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-breakfast-post';
import { apiHotelStatisticalReportDinnerPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-dinner-post';
import { ApiHotelStatisticalReportDinnerPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-dinner-post';
import { apiHotelStatisticalReportExtraServicePost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-extra-service-post';
import { ApiHotelStatisticalReportExtraServicePost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-extra-service-post';
import { apiHotelStatisticalReportIncommingsPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-incommings-post';
import { ApiHotelStatisticalReportIncommingsPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-incommings-post';
import { apiHotelStatisticalReportLunchPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-lunch-post';
import { ApiHotelStatisticalReportLunchPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-lunch-post';
import { apiHotelStatisticalReportOutgoingsPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-outgoings-post';
import { ApiHotelStatisticalReportOutgoingsPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-outgoings-post';
import { apiHotelStatisticalReportResidentsPost } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-residents-post';
import { ApiHotelStatisticalReportResidentsPost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-hotel-statistical-report-residents-post';
import { apiSupportCachedGet } from '../fn/moghim-hotel-supplier-panel-api/api-support-cached-get';
import { ApiSupportCachedGet$Params } from '../fn/moghim-hotel-supplier-panel-api/api-support-cached-get';
import { apiSupportResetCachePost } from '../fn/moghim-hotel-supplier-panel-api/api-support-reset-cache-post';
import { ApiSupportResetCachePost$Params } from '../fn/moghim-hotel-supplier-panel-api/api-support-reset-cache-post';
import { CachedTokenListInfo } from '../models/cached-token-list-info';

@Injectable({ providedIn: 'root' })
export class MoghimHotelSupplierPanelApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSupportCachedGet()` */
  static readonly ApiSupportCachedGetPath = '/api/support/cached';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportCachedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportCachedGet$Response(params?: ApiSupportCachedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CachedTokenListInfo>>> {
    return apiSupportCachedGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportCachedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportCachedGet(params?: ApiSupportCachedGet$Params, context?: HttpContext): Observable<Array<CachedTokenListInfo>> {
    return this.apiSupportCachedGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CachedTokenListInfo>>): Array<CachedTokenListInfo> => r.body)
    );
  }

  /** Path part for operation `apiSupportResetCachePost()` */
  static readonly ApiSupportResetCachePostPath = '/api/support/resetCache';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportResetCachePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSupportResetCachePost$Response(params: ApiSupportResetCachePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiSupportResetCachePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportResetCachePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSupportResetCachePost(params: ApiSupportResetCachePost$Params, context?: HttpContext): Observable<void> {
    return this.apiSupportResetCachePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportBreakfastPost()` */
  static readonly ApiHotelStatisticalReportBreakfastPostPath = '/api/hotel/StatisticalReport/Breakfast';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportBreakfastPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportBreakfastPost$Response(params?: ApiHotelStatisticalReportBreakfastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportBreakfastPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportBreakfastPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportBreakfastPost(params?: ApiHotelStatisticalReportBreakfastPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportBreakfastPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportLunchPost()` */
  static readonly ApiHotelStatisticalReportLunchPostPath = '/api/hotel/StatisticalReport/lunch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportLunchPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportLunchPost$Response(params?: ApiHotelStatisticalReportLunchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportLunchPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportLunchPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportLunchPost(params?: ApiHotelStatisticalReportLunchPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportLunchPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportDinnerPost()` */
  static readonly ApiHotelStatisticalReportDinnerPostPath = '/api/hotel/StatisticalReport/Dinner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportDinnerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportDinnerPost$Response(params?: ApiHotelStatisticalReportDinnerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportDinnerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportDinnerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportDinnerPost(params?: ApiHotelStatisticalReportDinnerPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportDinnerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportExtraServicePost()` */
  static readonly ApiHotelStatisticalReportExtraServicePostPath = '/api/hotel/StatisticalReport/ExtraService';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportExtraServicePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportExtraServicePost$Response(params?: ApiHotelStatisticalReportExtraServicePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportExtraServicePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportExtraServicePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportExtraServicePost(params?: ApiHotelStatisticalReportExtraServicePost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportExtraServicePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportIncommingsPost()` */
  static readonly ApiHotelStatisticalReportIncommingsPostPath = '/api/hotel/StatisticalReport/Incommings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportIncommingsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportIncommingsPost$Response(params?: ApiHotelStatisticalReportIncommingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportIncommingsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportIncommingsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportIncommingsPost(params?: ApiHotelStatisticalReportIncommingsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportIncommingsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportOutgoingsPost()` */
  static readonly ApiHotelStatisticalReportOutgoingsPostPath = '/api/hotel/StatisticalReport/Outgoings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportOutgoingsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportOutgoingsPost$Response(params?: ApiHotelStatisticalReportOutgoingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportOutgoingsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportOutgoingsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportOutgoingsPost(params?: ApiHotelStatisticalReportOutgoingsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportOutgoingsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelStatisticalReportResidentsPost()` */
  static readonly ApiHotelStatisticalReportResidentsPostPath = '/api/hotel/StatisticalReport/Residents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelStatisticalReportResidentsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportResidentsPost$Response(params?: ApiHotelStatisticalReportResidentsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelStatisticalReportResidentsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelStatisticalReportResidentsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelStatisticalReportResidentsPost(params?: ApiHotelStatisticalReportResidentsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelStatisticalReportResidentsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelHotelSellReportPost()` */
  static readonly ApiHotelHotelSellReportPostPath = '/api/hotel/HotelSellReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelHotelSellReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellReportPost$Response(params: ApiHotelHotelSellReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelHotelSellReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelHotelSellReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellReportPost(params: ApiHotelHotelSellReportPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelHotelSellReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiHotelHotelSellChangeReportPost()` */
  static readonly ApiHotelHotelSellChangeReportPostPath = '/api/hotel/HotelSellChangeReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelHotelSellChangeReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellChangeReportPost$Response(params: ApiHotelHotelSellChangeReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiHotelHotelSellChangeReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelHotelSellChangeReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellChangeReportPost(params: ApiHotelHotelSellChangeReportPost$Params, context?: HttpContext): Observable<void> {
    return this.apiHotelHotelSellChangeReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
